export default __webpack_public_path__ + "static/media/home-column.38cdf763.jpg";